import React, { PureComponent } from 'react';

import icons from '../shared/treatedIcons';
import {
  Wrapper,
  ContainerIcon,
  LoadingIconWrap,
  TitleLoading,
  TextLoading
} from './containerLoading.styled';

const { LoadingCircle, ReportAlert } = icons;

export default class ContainerLoading extends PureComponent {
  static defaultProps = {
    size: 'small',
    text: 'Em alguns instantes a ANALISE será concluída.',
    textLoading: "Processamento mais lento que o habitual...",
    textLoadingExpired: "Alguma de nossas capturas de dados está passando por instabilidade. Aguarde alguns minutos e atualize a tela (tecla F5) para verificar a conclusão dos laudos, ou retorne ao resumo da solicitação. Pedimos desculpas pelo transtorno.",
    showIcon: true,
    showFirstIcon: true,
    showSecondIcon: true,
    showText: true,
    fullWidth: true,
    lightAlert: false,
    margin: 'auto'
  }

  state = {
    showTextSlow: false,
    expired: false
  }

  componentDidMount() {
    this.beginCounter();
  }

  beginCounter = () => {
    setTimeout(() => {
      this.setState({ showTextSlow: true });
      setTimeout(() => {
        this.setState({ showTextSlow: false, expired: true });
      }, 20000);
    }, 40000);
  }

  renderText = () => {
    const { showText, text, textLoading, textLoadingExpired } = this.props;
    const { expired, showTextSlow } = this.state;
    if (showText) {
      if (showTextSlow) {
        return (<TextLoading data-testid="loadingText">{ textLoading }</TextLoading>);
      }

      if (expired) {
        return (<TextLoading data-testid="loadingText" className="loading-text--emphasis">{ textLoadingExpired }</TextLoading>);
      }

      return (<TextLoading data-testid="loadingText">{ text }</TextLoading>);
    }
    return null;
  }

  renderIcon = () => {
    const { showIcon, showFirstIcon, showSecondIcon, showText, lightAlert } = this.props;
    const { expired } = this.state;
    if (showIcon) {
      if (expired && showSecondIcon) {
        const color = lightAlert? "color_border-light-gray" : "color_border-gray";
        return (<ReportAlert width="95px" height="95px" color={color} margin="0 auto" />);
      }

      if (showFirstIcon && !showText && !expired) {
        return (
          <LoadingIconWrap>
            <LoadingCircle width="55px" height="55px" color="color_border-gray" margin="0 auto" />
          </LoadingIconWrap>
        );
      }
      
      if (showIcon && showFirstIcon && showText && showText) {
        return (
          <ContainerIcon>
            <TitleLoading>Processando</TitleLoading>
            <LoadingIconWrap>
              <LoadingCircle width="52px" height="52px" color="color_border-gray" margin="0 auto" />
            </LoadingIconWrap>
          </ContainerIcon>
        );
      }
    }
    return null;
  }

  render() {
    const { size, fullWidth, margin } = this.props;
    return (
      <Wrapper size={size} fullWidth={fullWidth} margin={margin}>
        { this.renderIcon() }
        { this.renderText() }
      </Wrapper>
    );
  }
}
